import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from "@angular/router";
import {CounselingTableComponent} from "./components/assessment-table/counseling-table.component";
import {AddAssessmentComponent} from "./components/add-assessment/add-assessment.component";
import {AddIndividualSessionComponent} from "./components/add-individual-session/add-individual-session.component";
import {AddGroupSessionComponent} from "./components/add-group-session/add-group-session.component";
import {AllSessionTablesComponent} from "./components/all-session-tables/all-session-tables.component";
import {AuthGuard} from "../../auth.guard";
import {
  CounsellingReportDashboardComponent
} from "./counselling_reporting/counselling-report-dashboard/counselling-report-dashboard.component";
import {CounselingChildReportComponent} from "./counseling-child-report/counseling-child-report.component";
import {
  IndividualSessionTableComponent
} from "./components/individual-session-table/individual-session-table.component";
import {GroupSessionTableComponent} from "./components/group-session-table/group-session-table.component";
import {FollowUpQuestionComponent} from "./components/follow-up-question/follow-up-question.component";
import {FollowUpTableComponent} from "./components/follow-up-question/follow-up-table/follow-up-table.component";
import {
  CounsellingSessionReviewComponent
} from "./components/CounsellingSessionReview/counselling-session-review/counselling-session-review.component";
import {
  CounsellingSessionReviewListComponent
} from "./components/CounsellingSessionReview/counselling-session-review-list/counselling-session-review-list.component";
import {WorkUpdateListComponent} from "./components/workUpdate/work-update-list/work-update-list.component";
import {AddEditWorkUpdateComponent} from "./components/workUpdate/add-edit-work-update/add-edit-work-update.component";
import {EducationSopComponent} from "../education/components/education-sop/education-sop/education-sop.component";
import {CounsellingSopComponent} from "./components/counselling-sop/counselling-sop/counselling-sop.component";
import {
  EducationMomListComponent
} from "../education/components/education-mom/education-mom-list/education-mom-list.component";
import {
  AddEditEducationMomComponent
} from "../education/components/education-mom/add-edit-education-mom/add-edit-education-mom.component";
import {
  ViewEducationMomComponent
} from "../education/components/education-mom/view-education-mom/view-education-mom.component";
import {
  GroupSessionTopicsListComponent
} from "./components/group-session-topics/group-session-topics-list/group-session-topics-list.component";
import {
  AddEditGroupSessionTopicsComponent
} from "./components/group-session-topics/add-edit-group-session-topics/add-edit-group-session-topics.component";
import {
  ViewGroupSessionTopicsComponent
} from "./components/group-session-topics/view-group-session-topics/view-group-session-topics.component";

import {
  CounsellingHighlightListComponent
} from "./components/Highlights/counselling-highlight-list/counselling-highlight-list.component";
import {
  AddEditCounsellingHighlightsComponent
} from "./components/Highlights/add-edit-counselling-highlights/add-edit-counselling-highlights.component";
import {
  CounsellingInductionListComponent
} from "./components/counselling-induction/counselling-induction-list/counselling-induction-list.component";
import {
  AddEditInductionComponent
} from "./components/counselling-induction/add-edit-induction/add-edit-induction.component";
import {
  CounsellingCenterLogComponent
} from "./components/Counselling Centre Log/counselling-center-log/counselling-center-log.component";
import {
  AddEditCounsellingCentreLogComponent
} from "./components/Counselling Centre Log/add-edit-counselling-centre-log/add-edit-counselling-centre-log.component";
import {
  MomCounsellorsComponent
} from "./components/mom/mom-counsellors/mom-counsellors.component";
import {
  MomManagementComponent
} from "./components/mom/mom-management/mom-management.component";
import {
  MomTabsComponent
} from "./components/mom/mom-tabs/mom-tabs.component";
import {ViewInductionComponent} from "../education/components/induction/view-induction/view-induction.component";
import {
  ViewCounsellingInductionComponent
} from "./components/counselling-induction/view-counselling-induction/view-counselling-induction.component";

const routes: Routes = [
  {
    path: '',
    // redirectTo: 'categories',
    // component: CounselingTableComponent,
    component: AllSessionTablesComponent,
    children: [
      {
        path: 'add-assessment',
        component: AddAssessmentComponent
      }
    ]
  },
  {
    path: 'assessments/add-assessment',
    component: AddAssessmentComponent
  },
  {
    path: 'add-individual-session',
    pathMatch: "full",
    component: AddIndividualSessionComponent
  },
  {
    path: 'add-group-session',
    pathMatch: "full",
    component: AddGroupSessionComponent
  },
  {
    path: 'dashboard',
    component: CounsellingReportDashboardComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'counseling-report',
    component: CounselingChildReportComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'individual',
    component: IndividualSessionTableComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'group',
    component: GroupSessionTableComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'assessments',
    component: CounselingTableComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'reports',
    component: CounselingChildReportComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'follow-up-question',
    component: FollowUpQuestionComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'follow-up-table',
    component: FollowUpTableComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'follow-up-question/:id',
    component: FollowUpQuestionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'counselling-session-reviews-list',
    component: CounsellingSessionReviewListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'add-counselling-session-reviews',
    component: CounsellingSessionReviewComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-counselling-session-reviews/:id',
    component: CounsellingSessionReviewComponent,
    canActivate: [AuthGuard]
  },
  {
    path:'work-update-list',
    component: WorkUpdateListComponent,
    canActivate: [AuthGuard]
  },
  {
    path:'edit-work-update/:id',
    component: AddEditWorkUpdateComponent,
    canActivate: [AuthGuard]
  },
  {
    path:'add-work-update',
    component: AddEditWorkUpdateComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'counselling-sop',
    component: CounsellingSopComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'group-session-topics-list',
    component: GroupSessionTopicsListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'add-group-session-topics',
    component: AddEditGroupSessionTopicsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-group-session-topics/:id',
    component: AddEditGroupSessionTopicsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'group-session-topics-view/:id',
    component: ViewGroupSessionTopicsComponent,
    canActivate: [AuthGuard]
  },


  // {
  //   path: 'add-counselling-induction',
  //   component: CounsellingInductionTableComponent,
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'add-edit-counselling-induction',
    component:AddEditInductionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'add-edit-counselling-induction/:id',
    component:AddEditInductionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'counselling-highlight-list',
    component: CounsellingHighlightListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'add-edit-counselling-highlight',
    component: AddEditCounsellingHighlightsComponent,
    canActivate: [AuthGuard]
  },
  {
    path:'counselling-induction-list',
    component: CounsellingInductionListComponent,
    canActivate: [AuthGuard]
  },
  {
    path:'counselling-center-log',
    component: CounsellingCenterLogComponent,
    canActivate: [AuthGuard]
  },
  {
    path:'add-edit-counselling-centre-log',
    component: AddEditCounsellingCentreLogComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'counselling-mom-list',
    component: MomTabsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'mom-tabs',
    component: MomTabsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'mom-management',
    component: MomManagementComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'view-induction/:id',
    component: ViewCounsellingInductionComponent,
    canActivate: [AuthGuard]
  }
]

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes),
    CommonModule
  ],
  exports: [RouterModule]
})
export class CounselingRoutingModule {
}
